export enum AccountEventAction {
    ACCOUNT_SIDEBAR_MENU_CLICKED = 'navigation click',
    ACCOUNT_SIDEBAR_LOYALTY_CLICKED = 'cta click',
    ACCOUNT_SIDEBAR_SHOWCASE_CLICKED = 'promotion click'
}
